import React from "react";
import { Table } from "react-materialize";
import TableHead from "./RecipTableHead";
import TableBody from "./RecipTableBody";

export default function RecipTable({
  userData,
  data,
  handleEvents,
}) {
  return (
    <Table
      className="responsive-table"
      id="recip-table"
      style={{ marginTop: "30px" }}
    >
      <TableHead handleEvents={handleEvents} />
      <TableBody data={data} handleEvents={handleEvents} />
    </Table>
  );
}
